import { protectExistingNamespaceLiterals } from './protect-existing-namespace-literals.js'
import { replaceAdminDashToken } from './replace-admin-dash-token.js'
import { resolveAdminNamespace } from './resolve-admin-namespace.js'

export function applyAdminNamespaceToPath(filePath: string, namespaceValue: string): string {
  const namespace = resolveAdminNamespace(namespaceValue)

  const canonicalPath = filePath
    .replaceAll('lib/actions/auth/middleware.ts', 'lib/actions/auth/session.ts')
    .replaceAll('lib/actions/auth/auth.ts', 'lib/actions/auth/server.ts')
    .replaceAll('lib/actions/r2/r2.ts', 'lib/actions/r2/provider.ts')
    .replaceAll('lib/actions/resend/resend.ts', 'lib/actions/resend/provider.ts')
    .replaceAll(
      'lib/actions/mailchimp/mailchimp.ts',
      'lib/actions/mailchimp/add-to-mailchimp-audience.ts'
    )
    .replaceAll('(admin)', namespace.routeGroup)
    .replace(/@admin(?=\/|$)/g, namespace.alias)
    .replace(/\/api\/admin(?=\/|$)/g, namespace.apiPath)
    .replace(/(^|\/)admin(?=\/|$)/g, `$1${namespace.segment}`)

  const protectedNamespace = protectExistingNamespaceLiterals(canonicalPath, namespace)
  const namespacedPath = replaceAdminDashToken(protectedNamespace.value, namespace)

  return protectedNamespace.restore(namespacedPath)
}
